export const API_URL = 'https://stage.malllogisticsapi.com/api/';
